import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from './utils/http'
// import filters from '@/utils/filters'

let isSign = false

const checkSign = () => {
  if (isSign) return Promise.resolve()
  return http.post('/approval/apply/config-list').then((res) => {
    isSign = true
    Vue.prototype.status = res.status
  })
}

// Object.keys(filters).forEach((key: string) => Vue.filter(key, (filters as any)[key]))

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.meta.auth === false) return next()
  checkSign().then(() => next()).catch(() => {
    location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa204d0203b18787d&redirect_uri=${encodeURIComponent(`${location.origin}/oauth?redirect=${encodeURIComponent(to.fullPath)}`)}&response_type=code&scope=snsapi_base#wechat_redirect`)
  })
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
